var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5039 10.4999C26.1739 10.4999 10.5039 26.1699 10.5039 45.4999C10.5039 64.8298 26.1739 80.4999 45.5039 80.4999C64.8339 80.4999 80.5039 64.8298 80.5039 45.4999C80.5039 26.1699 64.8339 10.4999 45.5039 10.4999ZM0.00390625 45.4999C0.00390625 20.3709 20.375 -0.00012207 45.5039 -0.00012207C70.6329 -0.00012207 91.0039 20.3709 91.0039 45.4999C91.0039 55.5393 87.7524 64.8193 82.2451 72.3442L95.9525 86.0514C98.6861 88.7851 98.6862 93.2172 95.9525 95.9509C93.2189 98.6846 88.7867 98.6846 86.053 95.951L72.3452 82.2433C64.8208 87.7493 55.542 90.9999 45.5039 90.9999C20.375 90.9999 0.00390625 70.6288 0.00390625 45.4999ZM40.1877 27.0865C41.4492 21.3238 49.6547 21.2879 50.9665 27.0394L51.0268 27.305L51.0268 27.3052L51.0269 27.3057C51.0677 27.4856 51.1052 27.6512 51.1458 27.8242C52.6038 34.0342 57.6296 38.7792 63.9206 39.8737C69.9336 40.9198 69.9336 49.5518 63.9206 50.5979C57.596 51.6982 52.5503 56.4881 51.1228 62.747L50.9665 63.4322C49.6546 69.1838 41.4492 69.1478 40.1877 63.3851L40.059 62.7971C38.684 56.5156 33.6453 51.6903 27.3102 50.5882C21.3081 49.544 21.308 40.9276 27.3102 39.8834C33.6232 38.7851 38.6489 33.9895 40.0445 27.7401C40.0767 27.5959 40.1069 27.4573 40.1392 27.3088L40.1393 27.3084L40.1877 27.0865Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.294e3519d57465d18a70033860d47228.svg";
export { ForwardRef as ReactComponent };